import React from "react";
import Button from "@mui/material/Button";
import styles from "../../styles/Button/TinyButton";

function TinyButton(props) {
  const { children, onClick, disabled } = props;
  return (
    <Button disabled={disabled} onClick={onClick} sx={styles}>
      {children}
    </Button>
  );
}

export default TinyButton;
